var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('h3',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),_c('vue-c3',{staticClass:"chart-box",attrs:{"handler":_vm.handler}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-221f9eae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/brand/health/components/nutritionPlan/GlucoseCurveChart.vue
// module id = null
// module chunks = 